import { useEffect, useState } from "react";
import {
    Container,
    Heading,
    HeadingWrapper,
    InfoDiv,
    InfoLink,
    LoadingCard,
    MentorCardWrapper,
    StartChatButton,
    StudentFormWrapper,
    SubHeading,
    SubHeadingWrapper,
} from "./Elements";
import MentorCard from "./MentorCard";
import { mentorQuery } from "./queries";
import "./font.css";
import { Alert, IconButton, Modal, Slide, Snackbar } from "@mui/material";
import ApiForm from "./ApiForm";
import { Box } from "@mui/system";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MenuIcon from "@mui/icons-material/Menu";
import FilterForm from "./FilterForm";
import tickAnimation from "../../assets/tick.json";
import Lottie from "lottie-react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// comment here

const ApiWidget = ({
    university = "boston",
    header = "Tel Aviv",
    fontFamily = "Outfit",
    headerColor = "black",
    headerElement = null,
    guest = false,
}) => {
    const [mentors, setMentors] = useState([]);
    const [filteredMentors, setFilteredMentors] = useState([]);
    const [selectedMentor, setSelectedMentor] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [showFilterForm, setShowFilterForm] = useState(false);
    const [specialization, setSpecialization] = useState([]);
    const [mentorFound, setMentorFound] = useState(true);
    const [loading, setLoading] = useState(true);

    const [showCheckmark, setShowCheckmark] = useState(false);

    const filtering = (filterObj) => {
        let oneMatchFound = false;
        const filtered = mentors.filter((m) => {
            const countryCheck = filterObj.country
                ? m.country === filterObj.country
                : true;
            const studyCheck = filterObj.study
                ? m.specialization === filterObj.study
                : true;

            const qualCheck = filterObj.qualification
                ? m.qualification === filterObj.qualification
                : true;

            if (countryCheck && studyCheck && qualCheck) oneMatchFound = true;

            return countryCheck && studyCheck && qualCheck;
        });

        console.log(filterObj);

        if (!oneMatchFound) {
            console.log("setting to all mentors", mentors);
            setMentorFound(false);
            setTimeout(() => setMentorFound(true), 1000);
            setFilteredMentors(mentors);
            return;
        } else {
            setSelectedMentor(null);
            setFilteredMentors(filtered);
        }
    };

    const [filter, setFilter] = useState({
        country: "",
        study: "",
        qualification: "",
    });

    const clearFilter = () => {
        setFilter({
            country: "",
            study: "",
            qualification: "",
        });
    };

    useEffect(() => {
        async function runQuery() {
            setLoading(true);
            const result = await mentorQuery();
            const mentorData = result.data;
            mentorData.sort((a, b) => a.name.localeCompare(b.name));
            const filteredMentors = mentorData.filter(
                (x) => x.university_mentor === university
            );
            let randomQualiMentor = filteredMentors.map((m) => ({
                ...m,
                // qualification: Math.round(Math.random() * 100) % 2 === 0 ? "ug" : "pg",
                qualification: "pg",
            }));

            if (guest) {
                randomQualiMentor = randomQualiMentor.filter(
                    (m) => m.guest === true
                );
            }

            setMentors(randomQualiMentor);
            setLoading(false);
        }
        runQuery();
    }, [university, guest]);

    useEffect(() => {
        setFilteredMentors(mentors);
        const s = new Set(mentors.map((m) => m.specialization));
        setSpecialization([...s]);
    }, [mentors]);

    const updateMentorSelection = (mentor) => {
        setSelectedMentor(mentor);
    };

    const isMobile = {
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
            return (
                navigator.userAgent.match(/IEMobile/i) ||
                navigator.userAgent.match(/WPDesktop/i)
            );
        },
        any: function () {
            return (
                isMobile.Android() ||
                isMobile.BlackBerry() ||
                isMobile.iOS() ||
                isMobile.Opera() ||
                isMobile.Windows()
            );
        },
    };

    const handleStartChatOnClick = (e) => {
        e.preventDefault();
        if (!selectedMentor) {
            setShowAlert(true);
        } else {
            setOpenModal(true);
        }
    };

    const handleWhatsappButtonClick = async (mentor) => {
        updateMentorSelection(mentor);
        // console.dir(formRef.current.click());
        setOpenModal(true);
    };
    const handleAlertClose = () => {
        setShowAlert(false);
    };

    const handleModalClose = () => {
        setOpenModal(false);
    };

    const openFilter = () => {
        setShowFilterForm(true);
    };
    const handleFilterClose = () => {
        setShowFilterForm(false);
    };

    let timeoutId = null;
    const showSuccessScreen = () => {
        setShowCheckmark(true);
        handleModalClose();
        timeoutId = setTimeout(() => setShowCheckmark(false), 10 * 1000);
    };

    const handleCloseSuccessScreen = () => {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = null;
        setShowCheckmark(false);
    };

    return (
        <Container>
            <HeadingWrapper headerColor={headerColor}>
                <Heading fontFamily={fontFamily}>
                    {header ? (
                        <>
                            Speak to {header} students <br /> on WhatsApp
                        </>
                    ) : (
                        headerElement
                    )}
                </Heading>
            </HeadingWrapper>
            <SubHeadingWrapper onClick={openFilter}>
                <IconButton style={{ marginRight: "6px" }}>
                    <MenuIcon />
                </IconButton>
                <SubHeading
                    fontFamily={fontFamily}
                    fontSize={fontFamily === "metric" ? "1.1rem" : "1rem"}
                >
                    Filter by country, specialization & more
                </SubHeading>
            </SubHeadingWrapper>
            <MentorCardWrapper style={{ overflow: "auto", maxHeight: "74.1%" }}>
                <Snackbar
                    open={showAlert}
                    autoHideDuration={3000}
                    onClose={handleAlertClose}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                    <Alert onClose={handleAlertClose} severity="error">
                        Please select a mentor
                    </Alert>
                </Snackbar>
                {!loading && (
                    <Snackbar
                        open={!mentorFound}
                        autoHideDuration={1000}
                        onClose={() => setMentorFound(true)}
                        anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    >
                        <Alert
                            onClose={() => setMentorFound(true)}
                            severity="warning"
                        >
                            Mentor not found !
                        </Alert>
                    </Snackbar>
                )}

                {filteredMentors.map((mentor) => (
                    <MentorCard
                        key={mentor._id}
                        mentor={mentor}
                        selected={mentor._id === selectedMentor?._id}
                        fontFamily={fontFamily}
                        onWhatsappButtonClick={handleWhatsappButtonClick}
                    />
                ))}

                {/* testing */}
                {loading && (
                    <>
                        <LoadingCard />
                        <LoadingCard />
                        <LoadingCard />
                        <LoadingCard />
                        <LoadingCard />
                        <LoadingCard />
                    </>
                )}
                {/* testing end */}

                <InfoDiv fontFamily={fontFamily}>
                    Powered by
                    <InfoLink
                        fontFamily={fontFamily}
                        target={"_blank"}
                        noreferrer
                        href="https://collegeit.org"
                    >
                        CollegeIt
                    </InfoLink>
                </InfoDiv>
            </MentorCardWrapper>
            <StudentFormWrapper
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {/* <Form
                    formRef={formRef}
                    onFormSubmit={handleFormSubmit}
                    mentor={selectedMentor}
                    fontFamily={fontFamily}
                /> */}
                <StartChatButton
                    fontFamily={fontFamily}
                    onClick={handleStartChatOnClick}
                >
                    <WhatsAppIcon
                        style={{ color: "white", marginRight: "8px" }}
                    />
                    Start WhatsApp Chat!
                </StartChatButton>
            </StudentFormWrapper>
            <Modal open={openModal} onClose={handleModalClose}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "min(360px, 90%)",
                        boxSizing: "border-box",
                        bgcolor: "white",
                        border: "2px solid #000",
                        padding: "11px",
                    }}
                >
                    <ApiForm
                        handleClose={handleModalClose}
                        mentor={selectedMentor}
                        showSuccessScreen={showSuccessScreen}
                    />
                </Box>
            </Modal>

            <Modal
                open={showFilterForm}
                onClose={handleFilterClose}
                closeAfterTransition
                keepMounted
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Slide direction="right" in={showFilterForm}>
                    <Box style={{ height: "100%" }}>
                        <FilterForm
                            onClose={handleFilterClose}
                            clearFilter={clearFilter}
                            setFilter={setFilter}
                            filter={filter}
                            university={university}
                            filterCb={filtering}
                            specialization={specialization}
                        />
                    </Box>
                </Slide>
            </Modal>

            <Modal
                open={showCheckmark}
                onClose={() => setShowCheckmark(false)}
                closeAfterTransition
            >
                <Slide direction="up" in={showCheckmark}>
                    <Box
                        style={{
                            height: "100%",
                            width: "100%",
                            background: "white",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "start",
                            paddingTop: "120px",
                            position: "relative",
                        }}
                    >
                        <IconButton
                            onClick={handleCloseSuccessScreen}
                            style={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                            }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <h1
                            style={{
                                width: "80%",
                                fontFamily: "Outfit",
                                fontSize: "23px",
                                textAlign: "center",
                                paddingBottom: "20px",
                            }}
                        >
                            Please give us 1 minute to connect you with your
                            mentor on WhatsApp
                        </h1>
                        <Lottie
                            {...{
                                loop: false,
                                autoplay: true,
                                animationData: tickAnimation,
                                rendererSettings: {
                                    preserveAspectRatio: "xMidYMid slice",
                                },
                            }}
                            height={100}
                            width={100}
                        />
                        <span
                            style={{
                                paddingTop: "28px",
                                fontFamily: "Outfit",
                                textAlign: "center",
                                color: "gray",
                                fontSize: "20px",
                                width: "80%",
                            }}
                        >
                            Please allow upto 24 hours for the mentor to respond
                        </span>
                    </Box>
                </Slide>
            </Modal>
        </Container>
    );
};

export default ApiWidget;
